import type { VoiceAgent } from '@circuitry-ai/doc-data';

/** `tools.form_capture_tool.enabled === true` */
export function isFormCaptureToolEnabled(tools: VoiceAgent['tools'] | undefined): boolean {
  const fct = tools?.form_capture_tool;
  return fct != null && typeof fct === 'object' && fct.enabled === true;
}

export function isVoiceAgentWithFormCapture(agent: VoiceAgent): boolean {
  return isFormCaptureToolEnabled(agent.tools);
}

/** Id sent to Lead `agentcall/web_RTC`. */
export function resolveVoiceAgentAssistantId(agent: VoiceAgent): string {
  return (agent.assistant_id ?? agent.id ?? '').trim();
}

export function voiceAgentDisplayLabel(agent: VoiceAgent): string {
  const name = agent.name?.trim();
  const id = resolveVoiceAgentAssistantId(agent);
  if (name && id) return `${name} (${id})`;
  return name || id || '—';
}
